import React, { useState, useEffect, useRef, useCallback } from 'react';
import style from './ServiceNoticeDetail.module.css';
import HeadSub from '../../../../components/comm/HeadSub';

import axiosApi from '../../../../api/daonAxios';
import CODE from '../../../../constants/code';
import { formatDate } from '../../../../assets/js/comm';

import ToastPopup from '../../../../components/comm/ToastPopup';
import { useLocation, useNavigate } from 'react-router-dom';


const ServiceNoticeDetail = () => {

    const location = useLocation();

    const { bbsMasId = null, bbsNttId = null } = location.state || {};

    const [toast, setToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');

    const [bbsDetail, setBbsDetail] = useState({});

    const contentRef = useRef(null);

    const handleOnJoinMeeting = (joinUrl) => {
        if (window.ReactNativeWebView) {
            window.ReactNativeWebView.postMessage(JSON.stringify({
                type: 'OPEN_EXTERNAL_URL',
                url: joinUrl
            }));
        } else {
            window.open(joinUrl, '_blank', 'noopener,noreferrer');
        }
    };

    const retrieveBbsDetail = useCallback(async () => {
        const url = "/notices/retrieveBbsDetail";
        const jToken = localStorage.getItem('jToken');
        const reqOptions = {
            headers: { Authorization: jToken },
        };
        await axiosApi.post(url, { bbsMasId: bbsMasId, bbsNttId: bbsNttId }, reqOptions)
            .then((res) => {
                if (res.data.resultCode === CODE.RCV_SUCCESS) {
                    setBbsDetail(prev => ({ ...prev, ...res.data.result.bbsDetail }));
                } else {
                    setToastMessage(res.data.resultMessage);
                    setToast(true);
                }
            })
            .catch(err => {
                console.error("게시물상세 결과 호출 중 오류  : ", err);
            })
    }, []);

    useEffect(() => {
        setTimeout(() => {
            retrieveBbsDetail();
        }, 50);
    }, []);

    useEffect(() => {
        const container = contentRef.current;
        if (!container) return;

        const handleClick = (e) => {
            const anchor = e.target.closest('a');
            if (!anchor || !container.contains(anchor)) return;

            e.preventDefault();
            e.stopPropagation();

            const url = anchor.getAttribute('href');
            if (url) {
                handleOnJoinMeeting(url);
            }
        };

        container.addEventListener('click', handleClick);
        return () => container.removeEventListener('click', handleClick);
    }, [bbsDetail.nttCn]);

    if (!bbsMasId || !bbsNttId) {
        alert('잘못된 접근 입니다.');
        return;
    }

    return (
        <>
            <HeadSub title="상세보기" />

            <div id="sub-content" data-layout="white">
                <div className='inner-wrap' data-pad="normal">
                    <div className={style['notice-detail-box']}>
                        <div className={style['head']}>
                            <p className={style['title']}>{bbsDetail.nttSj}</p>
                            <p className={style['bot-box']}>
                                <span>
                                    {bbsDetail.frstRgstDt
                                        ? formatDate(bbsDetail.frstRgstDt.substring(0, 10).replace(/-/g, ''))
                                        : ''}
                                </span>
                                <span>조회수 {bbsDetail.rdcnt}</span>
                            </p>
                        </div>

                        <div className={style['mid']}>
                            <div className={style['content']}>
                                <div className={style['txt-box']}>
                                    <div
                                        ref={contentRef}
                                        className="ck-content desc"
                                        dangerouslySetInnerHTML={{ __html: bbsDetail.nttCn }}
                                    ></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {toast && (
                <ToastPopup
                    setToast={setToast}
                    message={toastMessage}
                    position="center"
                    opacity="90"
                />
            )}
        </>
    );
};

export default ServiceNoticeDetail;